const SimpleTable = ({ rows = [] }) => (
  <table className="w-full border border-gray-200 text-sm">
    <tbody>
      {rows.map((cols, i) => (
        <tr key={i} className="border-b border-gray-200 last:border-0">
          {cols.map((cell, j) => (
            <td key={j} className={`px-4 py-3 border-r border-gray-200 last:border-0 ${j === 0 ? "text-gray-500 w-1/3" : "text-gray-700"}`}>
              {cell}
            </td>
          ))}
        </tr>
      ))}
    </tbody>
  </table>
);

export default SimpleTable;
